import React from "react";
import { Sheet, SheetContent } from "@/components/ui/sheet";

interface AddServiceSheetProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const AddServiceSheet: React.FC<AddServiceSheetProps> = ({ open, onClose, children }) => {
  return (
    <Sheet open={open} onOpenChange={onClose}>
      <SheetContent side="bottom" className="max-h-[95dvh] h-[95dvh] p-2 flex flex-col rounded-t-2xl shadow-2xl">
        <div className="flex-1 overflow-y-auto min-h-0">
          {children}
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default AddServiceSheet;